import React from "react";
import { connect, useSelector } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "react-virtualized-select/styles.css";
import "react-select/dist/react-select.css";
import "react-day-picker/lib/style.css";

import Homepage from "./containers/Homepage/Homepage";
import UnosZahtjeva from "./containers/UnosZahtjeva/UnosZahtjeva";
import PregledZahtjeva from "./containers/PregledZahtjeva/PregledZahtjeva";
import OdobrenjeZahtjeva from "./containers/OdobrenjeZahtjeva/OdobrenjeZahtjeva";
import KreiranjeRjesenja from "./containers/KreiranjeRjesenja/KreiranjeRjesenja";
import RegistarSamostalnihRevizora from "./containers/RegistarSamostalnihRevizora/RegistarSamostalnihRevizora";
import RegistarOvlastenihRevizora from "./containers/RegistarOvlastenihRevizora/RegistarOvlastenihRevizora";
import RegistarRevizorskihVjezbenika from "./containers/RegistarRevizorskihVjezbenika/RegistarRevizorskihVjezbenika";
import RegOvlRevizoraIzDrugihZemalja from "./containers/RegOvlRevizoraIzDrugihZemalja/RegOvlRevizoraIzDrugihZemalja";
import RegistarRevizorskihDrustava from "./containers/RegistarRevizorskihDrustava/RegistarRevizorskihDrustava";
import PregledRegistara from "./containers/PregledRegistara/PregledRegistara";

import User from "./containers/User/User";
import ControlMeasures from "./containers/ControlMeasures/ControlMeasures";
import RegistarRevDrustavIzDrugeDrzave from "./containers/RegistarRevDrustavaIzDrugeDrzave/RegistarRevDrustavaIzDrugeDrzave";
import StrucnaUsavrsavanja from "./containers/StrucnaUsavrsavanja/StrucnaUsavrsavanja";
import Organizer from "./containers/StrucnaUsavrsavanja/Organizatori/Organizer";
import PregledRegistra from "./containers/PregledRegistra/PregledRegistra";
import PregledStrucnogUsavrsavanja from "./containers/PregledStrucnogUsavrsavanja/PregledStrucnogUsavrsavanja";
import Odjava from "./containers/Odjava/Odjava";
import RegistarOvlastenihRevizoraIzTreceZemlje from "./containers/RegistarOvlastenihRevizoraIzTreceZemlje/RegistarOvlastenihRevizoraIzTreceZemlje";
import RegistarSubjekataRevizoraUtrecojZemlji from "./containers/RegistarSubjekataRevizoraUtrecojZemlji/RegistarSubjekataRevizoraUtrecojZemlji";
import Kontakt from "./containers/Kontakt/Kontakt";
import EvidencijeContainer from "./containers/EvidencijeContainer/EvidencijeContainer";
import Izvjestaj from "./containers/Izvjestaj/Izvjestaj";

import { Router } from "./router/router";
import PageNotFound from "./containers/PageNotFound/PageNotFound";
import SubjectChange from "./containers/SubjectChange/SubjectChange";
import SubjectChangeDenied from "./containers/SubjectChange/SubjectChangeDenied";
import Education from "./containers/StrucnaUsavrsavanja/Organizatori/Education";
import {YearlyPlan} from "./containers/StrucnaUsavrsavanja/GodPlan/YearlyPlan";

function App(props) {
  const { role, authority } = props;

  const isRoleAdmin = role === "ROLE_REFERENT" || role === "ROLE_SLUZBENIK";
  const isRoleAdminOrUser =
    role === "ROLE_KORISNIK" ||
    role === "ROLE_REFERENT" ||
    role === "ROLE_SLUZBENIK";

  const isOrganizer = authority?.ORGANIZATOR_EDUKACIJE === "true";

  const fontSize = useSelector((state) => state.layout.fontSize);
  const visionImpaired = useSelector((state) => state.layout.visionImpaired);

  return (
    <div className={visionImpaired ? "visionImpaired" : ""}>
      <BrowserRouter>
        <Switch>
          <Router
            path="/pregled-registara"
            component={PregledRegistara}
            condition
          />

          <Router
            path={["/unos-zahtjeva"]}
            component={UnosZahtjeva}
            condition={isRoleAdminOrUser}
          />
          <Router
            path="/pregled-zahtjeva"
            component={PregledZahtjeva}
            condition={isRoleAdminOrUser}
          />

          <Router
            path="/nadzorne-mjere"
            component={ControlMeasures}
            condition={isRoleAdminOrUser}
          />

          <Router
            path="/odobrenje-zahtjeva"
            component={OdobrenjeZahtjeva}
            condition={isRoleAdmin}
          />

          <Router
            path={[
              "/unos-u-registar/registar-revizorskih-drustava",
              "/azuriraj/registar-revizorskih-drustava/:id",
              "/azuriraj-po-zahtjevu/registar-revizorskih-drustava/:id",
            ]}
            component={RegistarRevizorskihDrustava}
            condition={isRoleAdmin}
          />
          <Router
            path={[
              "/unos-u-registar/registar-samostalnih-revizora",
              "/azuriraj/registar-samostalnih-revizora/:id",
              "/azuriraj-po-zahtjevu/registar-samostalnih-revizora/:id",
            ]}
            component={RegistarSamostalnihRevizora}
            condition={isRoleAdmin}
          />

          <Router
            path={[
              "/unos-u-registar/registar-ovlastenih-revizora",
              "/azuriraj/registar-ovlastenih-revizora/:id",
              "/azuriraj-po-zahtjevu/registar-ovlastenih-revizora/:id",
            ]}
            component={RegistarOvlastenihRevizora}
            condition={isRoleAdmin}
          />

          <Router
            path={[
              "/unos-u-registar/registar-revizorskih-vjezbenika",
              "/azuriraj/registar-revizorskih-vjezbenika/:id",
              "/azuriraj-po-zahtjevu/registar-revizorskih-vjezbenika/:id",
            ]}
            component={RegistarRevizorskihVjezbenika}
            condition={isRoleAdmin}
          />
          <Router
            path={[
              "/unos-u-registar/registar-ovlastenih-revizora-iz-trecih-zemalja",
              "/azuriraj/registar-ovlastenih-revizora-iz-trecih-zemalja/:id",
              "/azuriraj-po-zahtjevu/registar-ovlastenih-revizora-iz-trecih-zemalja/:id",
            ]}
            component={RegistarOvlastenihRevizoraIzTreceZemlje}
            condition={isRoleAdmin}
          />
          <Router
            path="/kreiranje-rjesenja/obrazac/:requestUuid"
            component={KreiranjeRjesenja}
            condition={isRoleAdmin}
          />
          <Router
            path={[
              "/unos-u-registar/registar-ovlastenih-revizora-iz-drugih-drzava-clanica",
              "/azuriraj/registar-ovlastenih-revizora-iz-drugih-drzava-clanica/:id",
              "/azuriraj-po-zahtjevu/registar-ovlastenih-revizora-iz-drugih-drzava-clanica/:id",
            ]}
            component={RegOvlRevizoraIzDrugihZemalja}
            condition={isRoleAdmin}
          />
          <Router
            path={[
              "/unos-u-registar/registar-revizorskih-drustava-iz-drugih-drzava-clanica",
              "/azuriraj/registar-revizorskih-drustava-iz-drugih-drzava-clanica/:id",
              "/azuriraj-po-zahtjevu/registar-revizorskih-drustava-iz-drugih-drzava-clanica/:id",
            ]}
            component={RegistarRevDrustavIzDrugeDrzave}
            condition={isRoleAdmin}
          />

          <Router
            path={[
              "/unos-u-registar/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji",
              "/azuriraj/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji/:id",
              "/azuriraj-po-zahtjevu/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji/:id",
            ]}
            component={RegistarSubjekataRevizoraUtrecojZemlji}
            condition={isRoleAdmin}
          />
          <Router
            path="/nadzorne-mjere"
            component={ControlMeasures}
            condition={isRoleAdmin}
          />

          <Router
            path="/strucna-usavrsavanja"
            component={StrucnaUsavrsavanja}
            condition={isRoleAdminOrUser}
          />

          <Router
            path="/pregled-strucnih-usavrsavanja/:idOsobe"
            component={PregledStrucnogUsavrsavanja}
            condition={isRoleAdminOrUser}
          />

          <Router
            path="/organizatori"
            component={Organizer}
            condition={isRoleAdmin || isOrganizer}
          />

          <Router
            path="/edukacije"
            component={Education}
            condition={isRoleAdminOrUser}
          />

          <Router
            path="/godPlan"
            component={YearlyPlan}
            condition={isOrganizer}
          />

          <Router
            path="/odjava"
            component={Odjava}
            condition={isRoleAdminOrUser}
          />

          <Router
            path="/pregled-registra/obrazac/:formId"
            component={PregledRegistra}
            condition
          />

          <Router
            path="/izvjestaj"
            component={Izvjestaj}
            condition={isRoleAdmin}
          />

          <Router path="/kontakt" component={Kontakt} condition />

          <Router
            path="/evidencije"
            component={EvidencijeContainer}
            condition={isRoleAdminOrUser}
          />

          <Route path="/user" component={User} />

          <Router
            path="/e-ovlastenja-front/promjena-subjekta/ForPersonOib/:personOib/ForLegalIps/:forLegalIps/ForLegalIzvor_reg/:legalIzvor/ToLegalIps/:toLegalIps/ToLegalIzvor_reg/:toLegalIzvor"
            component={SubjectChange}
            exact
            condition
          />

          <Route path="/subject-change-denied" component={SubjectChangeDenied}
            exact />

          <Route exact path="/page-not-found" component={PageNotFound} />

          <Router path="/" exact component={Homepage} condition />


        </Switch>
      </BrowserRouter>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    role: state.authentication.userData
      ? state.authentication.userData.roles[0].roleName
      : "",
    isAuthenticated: state.authentication.isAuthenticated,
    authority: state.authentication.authority ? state.authentication.authority : {},
  };
};

export default connect(mapStateToProps)(App);
